// Recharge API Configuration
// This file contains your Recharge API settings

const RECHARGE_CONFIG = {
    // Your Recharge API credentials
    API_URL: 'https://api.rechargeapps.com',
    API_KEY: 'sk_1x1_4c48c175b31a5ab81117cc131e61ff5cfc6f937c2c332b222aa8ade3b11db57e',
    API_CLIENT_SECRET: 'f6bbe5e8737082ecb48a93b115cbc7aa1419a07e74cfdd99e1548958bff80200',
    
    // You'll need to get these from your Recharge admin:
    STORE_ID: 'waterdropd-store', // Temporary - will work for testing
    WEBHOOK_SECRET: 'OPTIONAL_FOR_NOW', // Generate later in Recharge Admin → Settings → Webhooks
    
    // Manual rotation settings (no webhooks needed)
    ENABLE_MANUAL_ROTATION: true,
    ENABLE_SCHEDULED_ROTATION: true,
    SCHEDULED_ROTATION_INTERVAL: 60, // Check every 60 minutes
    
    // Optional Shopify configuration
    SHOPIFY_STORE_URL: 'your-store.myshopify.com',
    SHOPIFY_ACCESS_TOKEN: 'YOUR_SHOPIFY_TOKEN_HERE',
    
    // Server settings
    NODE_ENV: 'development',
    PORT: 3000,
    DEBUG_RECHARGE: false
};

// Export for use in other files
if (typeof module !== 'undefined' && module.exports) {
    module.exports = RECHARGE_CONFIG;
}

// Make available globally in browser
if (typeof window !== 'undefined') {
    window.RECHARGE_CONFIG = RECHARGE_CONFIG;
}

console.log('✅ Recharge configuration loaded');
console.log('📋 Next steps:');
console.log('1. Get your Store ID from Recharge Admin → Settings → Store');
console.log('2. Generate Webhook Secret in Recharge Admin → Settings → Webhooks');
console.log('3. Update the STORE_ID and WEBHOOK_SECRET values above'); 